// The auth context lives on its own, away from the provider component: a module
// that exports both a component and something else breaks React Fast Refresh
// (and trips react-refresh/only-export-components). Three small files instead
// of one disabled rule.

import { createContext } from 'react'

import type { Profile, Role } from '../types'

/** Roles are ordered: an admin can do whatever an analyst can. */
export const ROLE_RANK: Record<Role, number> = { reader: 1, analyst: 2, admin: 3 }

export interface AuthState {
  profile: Profile | null
  /** True until the initial session probe has answered. */
  loading: boolean
  login: (email: string, password: string, totp?: string) => Promise<void>
  logout: () => Promise<void>
  /** True when the current profile has at least the given role. */
  hasRole: (role: Role) => boolean
}

export const AuthContext = createContext<AuthState | null>(null)
